<template>
  <el-card class="list">
    <div slot="header">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{name: 'users'}">
          Users
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="card-toolbar">
        <fuzzy-search collection-name="users" :properties="['id', 'user_name', 'email', 'status']"></fuzzy-search>
        <el-button-group>
          <el-button size="mini" @click="fetchAll">
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </el-button>
          <el-button size="mini" @click="download" :loading="downloadBusy">
            <i class="fa fa-file-excel-o" aria-hidden="true"></i>
          </el-button>
        </el-button-group>
      </div>
    </div>
    <paginator collection-name="users"></paginator>
    <el-table :data="users" style="width: 100%" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70"></el-table-column>
      <el-table-column prop="user_name" label="USERNAME" sortable></el-table-column>
      <el-table-column prop="email" label="EMAIL" sortable></el-table-column>
      <el-table-column prop="status" label="STATUS" sortable></el-table-column>
      <el-table-column prop="registration_time" label="REGISTRATION" sortable :formatter="dateFormatter"></el-table-column>
      <el-table-column width="42" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click.prevent="userDetails(scope.row.id)">
            <i class="fa fa-address-card-o" aria-hidden="true"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

const pick = ({id, email, user_name: name, registration_time: time, language}) => [id, email, name, new Date(time), language]

export default {
  data () {
    return {
      users: [],
      downloadBusy: false
    }
  },

  computed: {
    ...mapState('users', {
      ids: state => state.paginator.ids,
      entities: state => state.entities,
      allIds: state => state.ids,
      loading: state => state.loading
    })
  },

  watch: {
    ids () {
      this.users = this.ids.map(id => this.entities[id])
    }
  },

  methods: {
    userDetails (id) {
      this.select(id)
      this.$router.push({ name: 'user', params: { id: id } })
    },
    dateFormatter (row, col) {
      return moment(row.registration_time).format('ll')
    },
    download () {
      this.downloadBusy = true
      const header = ['id', 'email', 'user_name', 'registration_time', 'language']
      const data = [header, ...this.allIds.map(id => pick(this.entities[id]))]
      require.ensure([], () => {
        const { save } = require('@/utils/xlsx-export')
        save('Users', data)
        this.downloadBusy = false
      }, 'xlsx')
    },
    ...mapActions('users', {
      fetchAll: 'fetchAll',
      select: 'select'
    })
  },

  created () {
    if (!this.$store.state.users.loaded) {
      this.fetchAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/Users.vue